export default __webpack_public_path__ + "static/21-214ee5af9b7f6d39dc8344b0b61643a4.webp";